import React from "react";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import PropTypes from "prop-types";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import { buttonVariants } from "@visiblethread/react-components/dist/components/Button";
import CategoriesActionsDropdown from "layout/dictionarySearch/CategoriesActionsDropdown";
import { getDictionaries } from "slices/dictionarySearch/actions/categories";
import { useDispatch } from "react-redux";
import { getDropdownTitle } from "utils/dictionarySearch";

const Header = ({ dictionary, categoryCount, docId }) => {
  const dispatch = useDispatch();
  return (
    <div className="categories__header" data-testid="categories-header">
      <div className="categories__header__title">
        <div className="categories__header__title-container">
          <span className="categories__header__title-container__dictionary">
            Dictionary
          </span>
          <Dropdown
            type={dropdownTypes.buttons}
            propsObject={{
              button: <span>{dictionary.name}</span>,
              title: getDropdownTitle(dictionary.name, dictionary.description),
              options: [
                <ButtonsDropdownOption
                  key="change"
                  content="Change Dictionary"
                  onClick={() => dispatch(getDictionaries(docId))}
                />,
                <ButtonsDropdownOption
                  key="goTo"
                  content="Go To Dictionary"
                  onClick={() => {
                    window.location.href = `/dictionaries/#/${dictionary.id}`;
                  }}
                />,
              ],
              buttonVariant: buttonVariants.borderless,
            }}
          />
        </div>
      </div>
      <div className="categories__header__table_header">
        <span className="categories__header__table_header__categories">{`Categories (${categoryCount})`}</span>
        <CategoriesActionsDropdown />
        <span className="categories__header__table_header__frequency">
          Freq
        </span>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  dictionary: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    description: PropTypes.string,
  }),
  categoryCount: PropTypes.number.isRequired,
  docId: PropTypes.number,
};
